<div class="ibox">
    <iboxtools
        *ngIf="sueldo != null"
        [Title]=""
        [isHistory]=true
        [DateInit]="sueldo?.desde"
        [DateEnd]="sueldo?.hasta"
        [PeriodList]="sueldoBasicoHistoryList"
        [IsEditing]="isEditing"
        (PeriodChange)="OnPeriodChange($event)"
        (NewChange)="OnNewChange($event)"
        (EditChange)="OnEditChange($event)"
        (SaveChange)="OnSaveChange($event)"
        (CutChange)="OnCutChange($event)"
        (DeleteChange)="OnDeleteChange($event)"
        (CancelChange)="OnCancelChange($event)"
        [Permiso]="permisoEdicion"
    ></iboxtools> 
    <div class="ibox-content" *ngIf="sueldo != null">
      <mat-error *ngIf="sueldoInvalida" class="sueldoInvalida">{{MensajeError}}</mat-error>
      <mat-error *ngIf="MensajeRetro && !sueldoInvalida && isEditing" class="sueldoInvalida">{{MensajeRetro}}</mat-error>
      <form [formGroup]="form">
        <div class="row" hidden="true">
          <input formControlName="id" name="id" type="text" class="form-control" />
          <input formControlName="personal" name="personal" type="text" class="form-control" />
        </div>
        <div class="row panel panel-warning" *ngIf="!disabledEditing">
          <div class="col-lg">
            <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
            <div class="col-lg-8">
              <p-calendar appendTo="body" selectOtherMonths="true" formControlName="desde" required dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
              <div *ngIf="registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched)" class="text-danger">La Fecha es Requerida</div>
              <mat-error *ngIf="desdeAnterior && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
                No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
              </mat-error>
              <mat-error *ngIf="anteriorRetroactividad && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
                No puede ser anterior al límite de retroactividad {{gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
              </mat-error>
            </div>
          </div>
          <div class="col-lg">
            <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
            <div class="col-lg-8">
              <p-calendar appendTo="body" selectOtherMonths="true" formControlName="hasta" required dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
              <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)" class="text-danger">La Fecha es Requerida</div>
              <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)">
                La Fecha no puede ser menor que la Fecha Desde
              </mat-error>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg">
            <label class="col-form-label font-bold">Estructura Salarial</label>
            <div>
              <comboTools [list]=estructuraSalariales
                          selected='estructuraSalarialId'
                          [formParent]="form"
                          [isEditing]=disabledEditing
                          filter="descripcion"
                          soloDescri=true
                          (SelectedChange)="cargarConceptos()"
                          ph='Estructura Salarial'></comboTools>
              <div *ngIf="registerFormControl.estructuraSalarialId.invalid && (registerFormControl.estructuraSalarialId?.dirty || registerFormControl.estructuraSalarialId?.touched || submitted)" class="text-danger">
                Estructura Salarial es Requerido
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg">
            <label class="col-form-label font-bold">Nivel</label>
            <div>
                <comboTools
                    [list]=nivelList
                    selected='nivel'
                    [formParent]="form"
                    [isEditing]=disabledEditing
                    filter="descripcion"
                    (SelectedChange)="cargarConceptos()"
                    ph= 'Nivel'
                ></comboTools>
                <div *ngIf="registerFormControl.nivel.invalid && (registerFormControl.nivel?.dirty || registerFormControl.nivel?.touched || submitted)" class="text-danger">              
                    El Nivel es requerido
                </div>
            </div>
          </div> 
          <div class="col-lg">
            <label class="col-form-label font-bold">SubNivel</label>
            <div>
                <comboTools
                    [list]=subnivelList
                    selected='subNivel'
                    [formParent]="form"
                    [isEditing]=disabledEditing
                    filter="descripcion"
                    (SelectedChange)="cargarConceptos()"
                    ph= 'Subnivel'
                ></comboTools>
                <div *ngIf="registerFormControl.subNivel.invalid && (registerFormControl.subNivel?.dirty || registerFormControl.subNivel?.touched || submitted)" class="text-danger">              
                    El Subnivel es requerido
                </div>
            </div>
          </div> 
        </div>
        <br>
      </form>
      
      <!-- <button *ngIf="!onlyNew" class="btn btn-primary" (click)="aplicarEstructura()">Importar Estructura</button> -->
      <div *ngIf="!onlyNew">
        <div *ngIf="!disabledEditing" class="row wrapper white-bg page-heading">
          <div class="col-lg-12">
            <h2>
              <button *ngIf="permisoEdicion" type="button" pButton pRipple pTooltip="Agregar Concepto" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='addConcepto()'></button>
            </h2>
          </div>
        </div>
        <div class="table table-striped">
          <p-table #dt [value]="conceptosList" [rows]="10" [paginator]="true" [rowHover]="true" dataKey="id">
            <ng-template pTemplate="header">
              <tr>
                <th>Código</th>
                <th>Descripción</th>
                <th>Cantidad</th>
                <th>Importe</th>
                <th>Moneda</th>
                <th>Valor Manual</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-concepto let-rowIndex="rowIndex">
              <tr [ngClass]="{'modificado' : concepto.modificadoManualmente}">
                <td>{{concepto.codigoNominaNavigation.codigo}}</td>
                <td>{{concepto.codigoNominaNavigation.descripcion}}</td>
                <td class="text-right">{{concepto.cantidad}}</td>
                <td class="importe">{{concepto.importe | numeroDecimal}}</td>
                <td>{{concepto.monedaNavigation.descripcion}}</td>
                <td style="text-align: center;">
                  <mat-checkbox [(ngModel)]="concepto.modificadoManualmente" [disabled]=true>
                  </mat-checkbox>
                </td>
                <td>
                  <button *ngIf="concepto.modificadoManualmente && isEditing" pButton pRipple pTooltip="Editar" tooltipPosition="bottom" icon="pi pi-pencil" class="btn btn-xs btn-warning" (click)="editConcepto(concepto, rowIndex)"></button>
                  <button *ngIf="concepto.modificadoManualmente && isEditing" pButton pRipple pTooltip="Eliminar" tooltipPosition="bottom" icon="pi pi-trash" class="btn btn-xs  btn-danger" (click)="deleteConcepto(concepto, rowIndex)"></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr>
                <td class="pieSueldo">Total Sueldo Básico:</td>
                <td></td>
                <td></td>
                <td class="importe pieSueldo">{{totalImporte | numeroDecimal}}</td>
                <td class="pieSueldo p-text-left">{{monedaConcepto}}</td>
                <td></td>
                <td></td>
              </tr>
            </ng-template>
          </p-table>
        </div>

      </div>
      
      <form [formGroup]="form">
        <div *ngIf="!onlyNew" class="row">
          <div class="col-lg">
            <label class="col-form-label font-bold" for="fechaVer">Ver a Fecha</label>
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="fechaVer" dateFormat="dd/mm/yy" inputId="fechaVer" ngDefaultControl (ngModelChange)="cambioFechaVer()"></p-calendar>
            <mat-error *ngIf="verFueraRango && (registerFormControl.fechaVer?.dirty || registerFormControl.fechaVer?.touched || submitted)" class="text-danger">
              La fecha no se corresponde al período
            </mat-error>
          </div> 
          <div class="col-lg">

          </div>
        </div>
      </form>
      
    </div>
</div>

<div class="ibox-content m-b-sm border-bottom" *ngIf="sueldo == null && cargaCompleta">
  <button type="button" pButton pRipple pTooltip="Agregar" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='add()'></button>
  <div class="p-xs">
    <div class="float-left m-r-md">
      <i class="fa fa-globe text-navy mid-icon"></i>
    </div>
    <h2>Empleado sin Sueldo Básico</h2>
    <span>El empleado no tiene Sueldo Básico.</span>
  </div>
</div>
